module.exports = __webpack_public_path__ + "img/call-line.0b94bc1b.png";